import moment from 'moment';
import 'moment-timezone';

export default function countdown(){
	if( ! $('.countdown-date-new').length ) { return; }

  const dateString = document.querySelector('.countdown-date-new').innerHTML;
  const dateParts = dateString.split(' ');
  const day = dateParts[0];
  const month = dateParts[1];
  const year = dateParts[2].replace(',', '');
  const time = dateParts[3] + ' ' + dateParts[4];
  let timeZone = document.querySelector('#time-zone').innerHTML;

  const formattedDateString = `${month} ${day}, ${year} ${time}`;
  
  const timeZoneMap = {
    'PT': 'America/Los_Angeles',
    'ET': 'America/New_York',
    'CT': 'America/Chicago',
    'MT': 'America/Denver',
    'EST': 'America/New_York',
    'GMT-0400': 'America/New_York'
  };

  if (timeZoneMap[timeZone]) {
    timeZone = timeZoneMap[timeZone];
  }

  let countDownDate = moment.tz(formattedDateString, 'MMMM DD, YYYY h:mm A', timeZone);

  var x = setInterval(function() {
    const now = moment().tz(timeZone);
    const distance = countDownDate.diff(now);

    if (distance < 0) {
      document.querySelectorAll('.event-coundown-time').forEach(el => el.style.display = 'none');
      clearInterval(x);
      return;
    }

    const duration = moment.duration(distance);
    const days = Math.floor(duration.asDays());
    const hours = duration.hours();
    const minutes = duration.minutes();
    const seconds = duration.seconds();

    document.querySelectorAll(".event-coundown-time").forEach(eventCountdow => {
      eventCountdow.innerHTML = `${days}d ${hours}h ${minutes}m ${seconds}s`;
    });

    if (distance < 0) { clearInterval(x); }
  }, 1000);
}